import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col ml-sidebar-rail desktop:ml-sidebar-open text-accent1 text-3xl font-extrabold fixed inset-0 items-center justify-center z-50"
    >
      <div className="loader" aria-hidden="true">
      </div>
      <span className="mt-5">
        Loading Notes
      </span>
    </div>
  );
};

export default LoadingScreen;
